export default [
  {
    group: "Step 1. Connect & Learn",
    blockSelector: "#main-wrapper > div > nav > ul.level_root.main-menu.vertical",
    itemSelector: "#main-wrapper > div > nav > ul.main-menu.level_root.vertical > li:nth-child(1) > a",
    title: "Home",
    text: "On the homepage, you will find essential information about the Talent Directory community and community's activity, your profile health, and future events.",
    step: 1,
    total: 5,
  },
  {
    group: "Step 1. Connect & Learn",
    blockSelector: "#main-wrapper > div > nav > ul.level_root.main-menu.vertical",
    itemSelector: "#main-wrapper > div > nav > ul.main-menu.level_root.vertical > li:nth-child(2) > a",
    title: "Activity",
    text: "See the latest activities of Women As One and the Talent Directory registrants.",
    step: 2,
    total: 5,
  },
  {
    group: "Step 1. Connect & Learn",
    blockSelector: "#main-wrapper > div > nav > ul.level_root.main-menu.vertical",
    itemSelector: "#main-wrapper > div > nav > ul.main-menu.level_root.vertical > li:nth-child(3) > a",
    title: "Community",
    text: "Search for any physicians registered in the Talent Directory. Filter your search to make it easier.",
    step: 3,
    total: 5,
  },
  {
    group: "Step 1. Connect & Learn",
    blockSelector: "#main-wrapper > div > nav > ul.level_root.main-menu.vertical",
    itemSelector: "#main-wrapper > div > nav > ul.main-menu.level_root.vertical > li:nth-child(4) > a",
    title: "Opportunity",
    text: "Get access to professional opportunities exclusive to Talent Directory registrants",
    step: 4,
    total: 5,
  },
  {
    group: "Step 1. Connect & Learn",
    blockSelector: "#main-wrapper > div > nav > ul.level_root.main-menu.vertical",
    itemSelector: "#main-wrapper > div > nav > ul.main-menu.level_root.vertical > li.menu_item.open.hasClickChild > a",
    title: "WAO Academy",
    text: "Learn and grow with our multi-topic learning resources in multiple formats.",
    step: 5,
    total: 5,
  },
  {
    group: "Step 2. The Wall",
    blockSelector: "#main-wrapper > div > nav > ul.menu-foot.bg-white, #main-wrapper > div > nav > div",
    itemSelector: "#main-wrapper > div > nav > ul.menu-foot.bg-white > li:nth-child(1) > a",
    title: "Need Help?",
    text: "We're here to help you! If you’re experiencing an issue, contact us and we’ll get back to you as soon as possible.",
    step: 1,
    total: 3,
  },
  {
    group: "Step 2. The Wall",
    blockSelector: "#main-wrapper > div > nav > ul.menu-foot.bg-white, #main-wrapper > div > nav > div",
    itemSelector: "#main-wrapper > div > nav > ul.menu-foot.bg-white > li:nth-child(2) > a",
    title: "Request a feature",
    text: "Have an idea to improve the Talent Directory so we can better support your career growth? Share it with us here!",
    step: 2,
    total: 3,
  },
  {
    group: "Step 2. The Wall",
    blockSelector: "#main-wrapper > div > nav > div, #main-wrapper > div > nav > ul.menu-foot.bg-white",
    itemSelector: "#main-wrapper > div > nav > div",
    title: "Invite physicians",
    text: "Know other women physicians who could benefit from the Talent Directory? Send them an invite!",
    step: 3,
    total: 3,
  },

  {
    group: "Step 3. Opportunity Space",
    blockSelector: "#main-wrapper > div > main > div > div.row > div.col-12.col-xl-8.d-flex.flex-column.justify-content-between",
    itemSelector: "#main-wrapper > div > main > div > div.row > div.col-12.col-xl-8.d-flex.flex-column.justify-content-between > div.statistic.text-center.text-lg-left.d-flex.bg-white.wrap-block.mb-3.flex-wrap > div.col-12.col-md-8",
    title: "Community Insights",
    text: "See the global growth of the Talent Directory community.",
    placement: "bottom",
    step: 1,
    total: 3,
  },
  {
    group: "Step 3. Opportunity Space",
    blockSelector: "#main-wrapper > div > main > div > div.row > div.col-12.col-xl-8.d-flex.flex-column.justify-content-between",
    itemSelector: "#main-wrapper > div > main > div > div.row > div.col-12.col-xl-8.d-flex.flex-column.justify-content-between > div.statistic.text-center.text-lg-left.d-flex.bg-white.wrap-block.mb-3.flex-wrap > div.col-12.col-md-4",
    title: "Get new opportunities",
    text: "Discover how we work to promote you to top healthcare organizations.",
    placement: "left",
    step: 2,
    total: 3,
  },

  {
    group: "Step 3. Opportunity Space",
    blockSelector: "#main-wrapper > div > main > div > div.row > div.col-12.col-xl-8.d-flex.flex-column.justify-content-between",
    itemSelector: "#main-wrapper > div > main > div > div.row > div.col-12.col-xl-8.d-flex.flex-column.justify-content-between > div.latest-notifications.position-relative.bg-white.flex-grow-1.wrap-block.mb-4.pb-5 > ul",
    title: "Community Activity",
    text: "Check out what updates the community have been making to their Talent Directory profiles.",
    placement: "top",
    step: 3,
    total: 3,
  },

  {
    group: "Step 4. Tracker Space",
    blockSelector: "#main-wrapper > header > div.row.top-bar > div.right-side.navbar > ul",
    itemSelector: "#main-wrapper > header > div.row.top-bar > div.right-side.navbar > ul > li.nav-item.massages",
    title: "Inbox",
    text: "Send and receive private messages with any physician registered in the Talent Directory.",
    placement: "left",
    step: 1,
    total: 4,
  },
  {
    group: "Step 4. Tracker Space",
    blockSelector: "#main-wrapper > header > div.row.top-bar > div.right-side.navbar > ul",
    itemSelector: "#main-wrapper > header > div.row.top-bar > div.right-side.navbar > ul > li.nav-item.custom-card > ul > li:nth-child(1) > a",
    title: "My settings",
    text: "Manage your account settings seamlessly here.",
    placement: "left",
    step: 2,
    total: 4,
    callback: ($) => {
      $("#main-wrapper > header > div.row.top-bar > div.right-side.navbar > ul > li.nav-item.custom-card").addClass("tutorial-hover");
    },
  },
  {
    group: "Step 4. Tracker Space",
    blockSelector: "#main-wrapper > header > div.row.top-bar > div.right-side.navbar > ul",
    itemSelector: "#main-wrapper > header > div.row.top-bar > div.right-side.navbar > ul > li.nav-item.custom-card > ul > li:nth-child(2) > a",
    title: "My profile",
    text: "Manage your professional profile and update your career milestones here.",
    placement: "left",
    step: 3,
    total: 4,
    callback: ($) => {
      $("#main-wrapper > header > div.row.top-bar > div.right-side.navbar > ul > li.nav-item.custom-card").addClass("tutorial-hover");
    },
  },

  {
    group: "Step 4. Tracker Space",
    blockSelector: "#main-wrapper > div > main > div > div.row > div.col-12.col-xl-4.right-block > div.mb-4.bg-white.wrap-block.profile-health",
    itemSelector: "#main-wrapper > div > main > div > div.row > div.col-12.col-xl-4.right-block > div:nth-child(1) > div",
    title: "Profile health",
    text: "Wondering how complete your profile is? This indicator will help you! To be considered into our talent searches, make sure your profile is always complete and up to date.",
    placement: "left",
    step: 4,
    total: 4,
    callback: ($) => {
      $("#main-wrapper > header > div.row.top-bar > div.right-side.navbar > ul > li.nav-item.custom-card").removeClass("tutorial-hover");
    },
  },
];
